/**
 * Supprime toutes les balises HTML de la chaîne de caractères donnée.
 *
 * @param {string} input La chaîne de caractères contenant potentiellement des balises HTML.
 * @returns {string} La chaîne de caractères nettoyée de toutes les balises HTML.
 */
export function stripTags(input) {
  return input.replace(/<\/?[^>]+(>|$)/g, "");
}
